inputs-complex-location-inserter
  .form-group.row
    .offset-md-4.col-12.col-md-8.recommendations
      .words-wrap
        .item.word(each="{label in opts.words}")
          span.btn-wrap.insert-btn
            span.btn.btn-sm.btn-info(onClick="{onClickInsert}")
              i.feather.icon-arrow-up
              | { label }
              pre
                | { label }
                |
      .item.recommendation(each="{opts.recommendations}")
        span.btn-wrap.insert-btn
          span.btn.btn-sm.icon-btn.btn-info(onClick="{onClickInsert}")
            i.feather.icon-arrow-up
            pre
              | { insert_content }
              |
        span.address
          span.to
            span.location_name(if="{location_name != ''}") { location_name }
            span.person_name(if="{person_name != ''}") { person_name }
            span.tel(if="{tel != ''}") { tel }
            span.tel_ext(if="{tel_ext != ''}") ({ tel_ext })
            br
            small.text-muted.address { address }
      .typeahead-wrap
        span.btn-wrap.insert-btn
          span.btn.btn-sm.icon-btn.btn-info(if="{locationPrepared()}" onClick="{onClickInsert}")
            i.feather.icon-arrow-up
            pre
              | { opts.insert_content }
              |
          span.btn.btn-sm.icon-btn.btn-disabled(if="{!locationPrepared()}")
            i.feather.icon-arrow-up
        .location-wrap
          .row
            .col-12.col-lg-8
              inputs-without-label-typeahead-single(tag-scope="{this.tagScope}.location_id")
            .col-12.col-lg-4
              inputs-without-label-typeahead-single(tag-scope="{this.tagScope}.locations_person_id")
  script(type="typescript").
    this.mixin('inputs.complex.location-inserter');
  style(scoped).
    .item {
      display: flex;
      margin-bottom: 1px;
    }
    span.address span {
      display: inline-block;
      line-height: 1rem;
    }
    .word .insert-btn {
      margin-right: 1px;
    }
    .recommendation .insert-btn {
      margin-right: 1rem;
    }
    .insert-btn pre {
      display: none;
    }
    .location_name,
    .person_name,
    .address {
      margin-right: 1rem;
    }
    .tel {
      margin-right: .5rem;
    }
    .typeahead-wrap {
      position: relative
    }
    .typeahead-wrap .insert-btn {
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
    }
    .location-wrap {
      margin-left: 60px;
    }
    .btn-disabled {
      cursor: not-allowed !important;
    }
    .words-wrap {
      display: flex;
    }
    .words-wrap {
      margin-bottom: 2px;
    }
